import { Navigate, Route, Routes } from 'react-router-dom';
import TestAddPage from './testAddPage';
import TestDetailPage from './testDetailPage';
import TestInformationDetailPage from './testItemDetailPage';
import TestInformationPage from './testInformationPage';
import TestListPage from './testListPage';

const TestRouter = () => {
  return (
    <>
      <Routes>
        <Route index element={<Navigate to={'check'} />} />
        <Route path="information" element={<TestInformationPage />} />
        <Route
          path="information/:itemCode"
          element={<TestInformationDetailPage />}
        />
        <Route path="check" element={<TestListPage />} />
        <Route path=":testId" element={<TestDetailPage />} />
        <Route path="order" element={<TestAddPage />} />
      </Routes>
    </>
  );
};

export default TestRouter;
